const rederectUrls = {
  development: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2ftest-public.cn.utools.club%2f&response_type=code&scope=snsapi_base&state=123#wechat_redirect',
  production: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2fsien.da300.com&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
}
const wxMenuUrl = {
  contribute: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2fsien.da300.com%2f%23%2fcontribute&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect',
  vip: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2fsien.da300.com%2f%23%2fvip&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
}

const orginUrl = process.env.NODE_ENV === 'development' ? rederectUrls.development : rederectUrls.production
export default {
  orginUrl,
  wxMenuUrl
}
// export default {
//   // 微信授权链接
//   // orginUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2ftest-public.cn.utools.club%2f&response_type=code&scope=snsapi_base&state=123#wechat_redirect'
//   orginUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4a696e431b0456b&redirect_uri=https%3a%2f%2fsien.da300.com&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
// }



// WEBPACK FOOTER //
// ./src/utils/config.js